import { createResource } from "~/lib/resourceFactory";
import { getFixedAsset, listFixedAssets } from "./fixed-assets.api";

type FixedAssetsPage = Awaited<ReturnType<typeof listFixedAssets>>;
type FixedAssetDetail = Awaited<ReturnType<typeof getFixedAsset>>;

export type FixedAssetDetailParams = { businessId: string; id: string };

export type FixedAssetsParams = {
  businessId: string;
  search?: string;
  ids?: string[];
  offset?: number;
  limit: number;
};

export const FixedAssetDetailResource = createResource<
  FixedAssetDetail,
  FixedAssetDetailParams
>({
  key: ({ businessId, id }) => ["fixed-asset", businessId, id] as const,
  fetcher: ({ businessId, id }) => getFixedAsset({ data: { businessId, id } }),
});

export const FixedAssetsResource = createResource<
  FixedAssetsPage,
  FixedAssetsParams
>({
  key: (p) =>
    [
      "fixed-asset",
      p.businessId,
      p.limit,
      p.search ?? "",
      p.ids === undefined ? "*" : p.ids.join(","),
      p.offset ?? 0,
    ] as const,
  fetcher: (p) =>
    listFixedAssets({
      data: {
        businessId: p.businessId,
        search: p.search,
        ids: p.ids,
        offset: p.offset,
        limit: p.limit,
      },
    }),
});
